export default {
    /* Reduction */
    reductionTitle: 'Reduser kredittgrensen',
    reductionIngress: 'Ønsker du mindre tilgjengelig kreditt på dine kredittkort? Det kan du enkelt gjøre her.',
    reductionSelectCreditText:
        'Du kan velge en grense som er mellom dagens kredittgrense og det du har brukt på kortet:',
    reductionSelectCreditCardLimit: 'Din kredittgrense:',
    reductionSelectCreditCardSaldo: 'Du har brukt:',
    reductionSelectCardName: 'Ditt kredittkort:',
    reductionSelectNewLimit: 'Ny kredittgrense',
    reductionConfirmationTitle: 'Er du sikker?',
    reductionConfirmationText1Pre: 'Ny kredittgrense vil bli satt til',
    reductionConfirmationText2: 'Den blir satt med en gang og du kan ikke angre.',
    reductionConfirmationText3: 'Husk at du må søke som vanlig for å øke kredittgrensen igjen.',
    reductionConfirmationButton: 'Bekreft ny kredittgrense',
    reductionReceiptTitle: 'Du har fått ny kredittgrense',
    reductionReceiptTextPre: 'Kredittgrensen på ditt',
    reductionReceiptTextPost: 'er nå endret til',
    reductionInvalidBalance: 'Beklager du har satt kortet ditt i overtrekk og kan derfor ikke redusere grensen.',
    reductionUnauthorized: 'Du har ikke lov til å gjennomføre endring av kredittgrense på dette kortet.',
    reductionUnauthorizedBusinessCard:
        'Du har ikke lov til å gjennomføre endring av kredittgrense her, vennligst bruk bedriftsportalen.',

    /* Reduction Error */
    reductionErrorHeader: 'Vi beklager!',
    reductionErrorText1: 'Vi kunne dessverre ikke gjennomføre reduksjon av kredittgrensen nå.',
    reductionErrorText2: 'Vi jobber med å løse feilen og du kan prøve igjen om en stund.',
    reductionErrorText3: 'Hvis det fortsatt ikke fungerer, ta kontakt med oss.',
    reductionErrorReturnButton: 'Gå tilbake',
    reductionErrorReturnLink: './',
    reductionErrorInfoBox: '{defaultInfoBoxText}',
    reductionLowestLimit: 'Du har allerede lavest mulig kredittgrense på dette kortet.',
    reductionStartOver: 'Prøv på nytt',
    reductionInvalidCreditLimit:
        'Vi kunne dessverre ikke redusere kredittgrensen din, ta kontakt med Kredittbanken på telefon 915 03 850 eller e-post kundesenter@eika.no for assistanse.',

    /* Reduction Error Handling */
    errorInvalidCardLimit: 'Vennligst velg et gyldig beløp',

    /* Increase limit */
    increaseLimitLbsUrl: 'https://lbkredittkort.test.eika.no',
    increaseLimitNorDirekteUrl: 'https://skagerraksparebank.test.eika.no/',
};
